<template>
  <!-- Contenido del sidebar con scroll -->
  <div class="flex-1 overflow-y-auto no-scrollbar">
    <!-- Navegación principal -->
    <nav class="px-4 py-4 space-y-2">
      <router-link 
        to="/agent-dashboard" 
        exact
        class="group relative flex items-center shrink-0 gap-3 h-12 px-3 text-sm font-medium rounded-xl transition-colors duration-200"
        :class="{ 
          'bg-white text-gray-900 shadow-md': route.path === '/agent-dashboard',
          'text-gray-600 hover:bg-gray-200 hover:text-gray-900': route.path !== '/agent-dashboard'
        }"
      >
        <HomeIcon class="h-5 w-5 mr-3" />
        <div class="flex-1">{{ $t('agentDashboard.navigation.home') }}</div>
        <span class="invisible w-10"></span> <!-- Espacio reservado para mantener alineación -->
      </router-link>

      <button 
        @click="handleNavigation('/agent-dashboard/clients', true)"
        class="group relative flex items-center shrink-0 gap-3 h-12 px-3 text-sm font-medium rounded-xl transition-colors duration-200 w-full text-left"
        :class="{ 
          'bg-white text-gray-900 shadow-md': isActive('/agent-dashboard/clients'),
          'text-gray-600 hover:bg-gray-200 hover:text-gray-900': !isActive('/agent-dashboard/clients')
        }"
      >
        <UsersIcon class="h-5 w-5 mr-3" />
        <div class="flex-1">{{ $t('agentDashboard.navigation.clients') }}</div>
        <span v-if="isNavProLocked" class="px-1.5 py-0.5 text-xs bg-indigo-700 text-white rounded-full">{{ $t('agentDashboard.quickActions.proLabel') }}</span>
        <span v-else class="invisible w-10"></span> <!-- Espacio reservado cuando no hay etiqueta -->
      </button>

      <!-- OCULTO: Acceso a propiedades tradicionales deshabilitado -->
      <!-- <router-link 
        to="/agent-dashboard/contracts" 
        class="group relative flex items-center shrink-0 gap-3 h-12 px-3 text-sm font-medium rounded-xl transition-colors duration-200"
        :class="{ 
          'bg-white text-gray-900 shadow-md': isActive('/agent-dashboard/contracts'),
          'text-gray-600 hover:bg-gray-200 hover:text-gray-900': !isActive('/agent-dashboard/contracts')
        }"
      >
        <DocumentTextIcon class="h-5 w-5 mr-3" />
        <div class="flex-1">{{ $t('agentDashboard.navigation.properties') }}</div>
        <span class="invisible w-10"></span>
      </router-link> -->

      <router-link 
        to="/agent-dashboard/colivings" 
        class="group relative flex items-center shrink-0 gap-3 h-12 px-3 text-sm font-medium rounded-xl transition-colors duration-200"
        :class="{ 
          'bg-white text-gray-900 shadow-md': isActive('/agent-dashboard/colivings'),
          'text-gray-600 hover:bg-gray-200 hover:text-gray-900': !isActive('/agent-dashboard/colivings')
        }"
      >
        <BuildingOffice2Icon class="h-5 w-5 mr-3" />
        <div class="flex-1">{{ $t('agentDashboard.navigation.colivings') }}</div>
        <span class="invisible w-10"></span> <!-- Espacio reservado para mantener alineación -->
      </router-link>

      <button
        type="button"
        @click="handleNavigation('/agent-dashboard/incidents', true)"
        class="group relative flex items-center shrink-0 gap-3 h-12 px-3 text-sm font-medium rounded-xl transition-colors duration-200 w-full text-left"
        :class="{
          'bg-white text-gray-900 shadow-md': isActive('/agent-dashboard/incidents'),
          'text-gray-600 hover:bg-gray-200 hover:text-gray-900': !isActive('/agent-dashboard/incidents')
        }"
      >
        <ExclamationTriangleIcon class="h-5 w-5 mr-3" />
        <div class="flex-1">Incidencias</div>
        <span
          v-if="!isNavProLocked && activeIncidentsCount > 0"
          class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-[10px] font-bold text-white bg-amber-500 rounded-full"
        >
          {{ activeIncidentsCount > 99 ? '99+' : activeIncidentsCount }}
        </span>
        <span v-else-if="isNavProLocked" class="px-1.5 py-0.5 text-xs bg-indigo-700 text-white rounded-full">{{ $t('agentDashboard.quickActions.proLabel') }}</span>
        <span v-else class="invisible w-10"></span>
      </button>

      <button
        type="button"
        @click="handleNavigation('/agent-dashboard/invoicing', true)"
        class="group relative flex items-center shrink-0 gap-3 h-12 px-3 text-sm font-medium rounded-xl transition-colors duration-200 w-full text-left"
        :class="{ 
          'bg-white text-gray-900 shadow-md': isActive('/agent-dashboard/invoicing'),
          'text-gray-600 hover:bg-gray-200 hover:text-gray-900': !isActive('/agent-dashboard/invoicing')
        }"
      >
        <DocumentTextIcon class="h-5 w-5 mr-3" />
        <div class="flex-1">Facturación</div>
        <span v-if="isNavProLocked" class="px-1.5 py-0.5 text-xs bg-indigo-700 text-white rounded-full">{{ $t('agentDashboard.quickActions.proLabel') }}</span>
        <span v-else class="invisible w-10"></span>
      </button>

      <router-link 
        to="/agent-dashboard/calendar" 
        class="group relative flex items-center shrink-0 gap-3 h-12 px-3 text-sm font-medium rounded-xl transition-colors duration-200"
        :class="{ 
          'bg-white text-gray-900 shadow-md': isActive('/agent-dashboard/calendar'),
          'text-gray-600 hover:bg-gray-200 hover:text-gray-900': !isActive('/agent-dashboard/calendar')
        }"
      >
        <CalendarDaysIcon class="h-5 w-5 mr-3" />
        <div class="flex-1">{{ $t('agentDashboard.navigation.calendar') }}</div>
        <span class="invisible w-10"></span> <!-- Espacio reservado para mantener alineación -->
      </router-link>
      
      <router-link 
        to="/agent-dashboard/profile" 
        class="group relative flex items-center shrink-0 gap-3 h-12 px-3 text-sm font-medium rounded-xl transition-colors duration-200"
        :class="{ 
          'bg-white text-gray-900 shadow-md': isActive('/agent-dashboard/profile'),
          'text-gray-600 hover:bg-gray-200 hover:text-gray-900': !isActive('/agent-dashboard/profile')
        }"
      >
        <UserCircleIcon class="h-5 w-5 mr-3" />
        <div class="flex-1">{{ $t('agentDashboard.navigation.profile') }}</div>
        <span v-if="profileIncomplete" class="px-1.5 py-0.5 text-xs bg-red-500 text-white rounded-full">!</span>
        <span v-else class="invisible w-10"></span> <!-- Espacio reservado cuando no hay alerta -->
      </router-link>
    </nav>

    <!-- Componente de resumen de navegación -->
    <!-- OCULTO: Props y eventos de contratos tradicionales eliminados -->
    <AgentResumenNav
      ref="resumenNav"
      :total-contracts="totalContracts"
      :total-colivings="totalColivings"
      :pre-assigned-users="preAssignedUsers"
      :total-interested="totalInterested"
      :highlighted-colivings="highlightedColivings"
      :pending-verifications-list="pendingVerificationsList"
      :detailed-recent-events="detailedRecentEvents"
      :recent-events="recentEvents"
      :dismissed-events-count="dismissedEventsCount"
      :clients="clients"
      :user-verification-data="userVerificationData"
      @go-to-coliving="$emit('go-to-coliving', $event)"
      @go-to-verifications="$emit('go-to-verifications')"
      @dismiss-event="$emit('dismiss-event', $event)"
      @clear-dismissed-events="$emit('clear-dismissed-events')"
    />

    <!-- Cerrar sesión y enlaces de pie de página -->
    <div class="px-4 py-6 mt-auto">
      <button 
        @click="$emit('logout')" 
        class="w-full py-2 px-4 text-sm font-medium text-center text-gray-700 bg-white border border-gray-300 rounded-full hover:bg-gray-100 transition-colors"
      >
        {{ $t('agentDashboard.navigation.logout') }}
      </button>

      <!-- Enlaces del footer -->
      <div class="flex justify-center items-center space-x-2 text-xs text-gray-500 mt-4">
        <router-link to="/privacy-policy" class="hover:text-gray-700 transition-colors">
          {{ $t('navigation.footer.privacyPolicy') }}
        </router-link>
        <span class="text-gray-400">|</span>
        <router-link to="/contact" class="hover:text-gray-700 transition-colors">
          {{ $t('navigation.footer.contact') }}
        </router-link>
        <span class="text-gray-400">|</span>
        <p>{{ $t('navigation.footer.copyright') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { getAuth } from 'firebase/auth'
import { 
  HomeIcon, 
  UsersIcon, 
  DocumentTextIcon, 
  ShieldCheckIcon, 
  UserCircleIcon, 
  ArrowLeftOnRectangleIcon,
  BuildingOffice2Icon,
  CalendarDaysIcon,
  ExclamationTriangleIcon
} from '@heroicons/vue/24/outline'
import AgentResumenNav from './AgentResumenNav.vue'
import { isCurrentUserBasicAgent, isCurrentUserLeadPartnerAgent } from '../../utils/agentRoleUtils'

const route = useRoute()
const router = useRouter()

// NUEVO: Estado para Basic Agents y referencia al componente hijo
const isBasicAgent = ref(false)
const isLeadPartnerAgent = ref(false)
const isNavProLocked = computed(() => isBasicAgent.value || isLeadPartnerAgent.value)
const resumenNav = ref(null)

// Badge de incidencias activas (polling cada 60s)
const activeIncidentsCount = ref(0)
let incidentsPollingTimer = null

async function fetchIncidentsCount() {
  try {
    const auth = getAuth()
    const user = auth.currentUser
    if (!user) return
    const token = await user.getIdToken()
    const response = await fetch('/api/agents/incidents/count', {
      headers: { Authorization: `Bearer ${token}` }
    })
    if (!response.ok) return
    const { data } = await response.json()
    activeIncidentsCount.value = data?.count ?? 0
  } catch (error) {
    console.error('[AgentSideNavbar] Error obteniendo contador de incidencias:', error)
  }
}

async function setupIncidentsCounter() {
  await fetchIncidentsCount()
  // Actualizar cada 60 segundos
  incidentsPollingTimer = setInterval(fetchIncidentsCount, 60_000)
}

const props = defineProps({
  totalContracts: {
    type: Number,
    default: 0
  },
  totalColivings: {
    type: Number,
    default: 0
  },
  preAssignedUsers: {
    type: Number,
    default: 0
  },
  totalInterested: {
    type: Number,
    default: 0
  },
  // OCULTO: Props de contratos tradicionales deshabilitados
  // contractsWithStats: {
  //   type: Array,
  //   default: () => []
  // },
  // highlightedContracts: {
  //   type: Array,
  //   default: () => []
  // },
  highlightedColivings: {
    type: Array,
    default: () => []
  },
  pendingVerificationsList: {
    type: Array,
    default: () => []
  },
  detailedRecentEvents: {
    type: Array,
    default: () => []
  },
  recentEvents: {
    type: Array,
    default: () => []
  },
  dismissedEventsCount: {
    type: Number,
    default: 0
  },
  clients: {
    type: Array,
    default: () => []
  },
  userVerificationData: {
    type: Map,
    default: () => new Map()
  },
  profileIncomplete: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits([
  // OCULTO: Eventos de contratos tradicionales deshabilitados
  // 'select-contract',
  // 'view-candidates', 
  // 'go-to-contract',
  'go-to-coliving',
  'go-to-verifications',
  'dismiss-event',
  'clear-dismissed-events',
  'logout'
])

const isActive = (path) => {
  if (path === '/agent-dashboard') {
    return route.path === path
  }
  return route.path.startsWith(path)
}

// NUEVO: Función para manejar clicks en funciones PRO
const handleNavigation = (path, isProFeature) => {
  if (isProFeature && isNavProLocked.value) {
    if (resumenNav.value) {
      resumenNav.value.openUpgradeModal()
    }
  } else {
    router.push(path)
  }
}

const getContractStatusClass = (contract) => {
  if (contract.assignedApplicant) {
    return 'bg-blue-100 text-blue-800'
  } else if (contract.interestedApplicants?.length > 0) {
    return 'bg-yellow-100 text-yellow-800'
  } else {
    return 'bg-gray-100 text-gray-800'
  }
}

const getContractStatusLabel = (contract) => {
  if (contract.assignedApplicant) {
    return 'Asignado'
  } else if (contract.interestedApplicants?.length > 0) {
    return 'Con interés'
  } else {
    return 'Activo'
  }
}

const formatCurrency = (amount) => {
  if (!amount) return ''
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0
  }).format(amount)
}

const getClientName = (clientId) => {
  if (!clientId) return 'Cliente no encontrado'
  const client = props.clients.find(c => c.id === clientId || c.firebaseAuthUid === clientId)
  return client ? client.fullName : 'Cliente no encontrado'
}

const getColivingClientName = (coliving) => {
  if (coliving.agentIsOwner) {
    return 'Tú (Agente)'
  }
  return getClientName(coliving.clientId)
}

const getOccupiedRoomsCount = (coliving) => {
  if (!coliving.rooms || !Array.isArray(coliving.rooms)) {
    return 0
  }
  return coliving.rooms.filter(room => room.status === 'ocupada').length
}

const getEventIconClass = (eventType) => {
  const classes = {
    // Eventos de contratos tradicionales
    contract: 'bg-green-100 text-green-600',
    signed: 'bg-green-100 text-green-600',
    assigned: 'bg-blue-100 text-blue-600',
    interest: 'bg-blue-100 text-blue-600',
    
    // Eventos de colivings generales
    coliving: 'bg-purple-100 text-purple-600',
    
    // Eventos específicos de aplicaciones de colivings
    coliving_application: 'bg-indigo-100 text-indigo-600',
    coliving_pre_approved: 'bg-cyan-100 text-cyan-600',
    coliving_signed: 'bg-green-100 text-green-600',
    coliving_payment: 'bg-emerald-100 text-emerald-600',
    coliving_assignment: 'bg-teal-100 text-teal-600',
    coliving_rejected: 'bg-red-100 text-red-600',
    coliving_terminated: 'bg-gray-100 text-gray-600',
    coliving_application_retired: 'bg-orange-100 text-orange-600',
    
    // Otros eventos
    verification: 'bg-yellow-100 text-yellow-600',
    default: 'bg-gray-100 text-gray-600'
  }
  return classes[eventType] || classes.default
}

const formatEventDate = (date) => {
  if (!date) return ''
  
  try {
    const dateObj = new Date(date)
    if (isNaN(dateObj.getTime())) {
      return ''
    }
    
    return new Intl.DateTimeFormat('es-ES', {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    }).format(dateObj)
  } catch (error) {
    console.warn('Error al formatear fecha:', date, error)
    return ''
  }
}

// NUEVO: Verificar tipo de agente y cargar contador al montar
onMounted(async () => {
  try {
    isBasicAgent.value = await isCurrentUserBasicAgent()
    isLeadPartnerAgent.value = await isCurrentUserLeadPartnerAgent()
    if (!isLeadPartnerAgent.value) {
      await setupIncidentsCounter()
    }
  } catch (error) {
    console.error('[AgentSideNavbar] Error verificando tipo de agente:', error)
  }
})

onUnmounted(() => {
  if (incidentsPollingTimer) clearInterval(incidentsPollingTimer)
})
</script> 

<style scoped>
/* Ocultar scrollbar para Chrome, Safari y Opera */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Ocultar scrollbar para IE, Edge y Firefox */
.no-scrollbar {
  -ms-overflow-style: none;  /* IE y Edge */
  scrollbar-width: none;  /* Firefox */
}
</style> 